<template>
  <div
    :class="
      `bg-loader ${this.dark && 'bg-loader--dark'} ${this.contentLoader &&
        'bg-loader--content'}`
    "
  ></div>
</template>

<style lang="scss" scoped>
@import "./style.scss";
</style>

<script>
export default {
  name: "bg-loader",
  props: {
    contentLoader: {
      type: Boolean,
      default: false
    },
    dark: {
      type: Boolean,
      default: false
    }
  }
};
</script>
